import {create} from "zustand";

interface GlobalContextState {
    projectID: number | null;
    storyID: number | null;
    tenantID: string | null;
    setProjectID: (projectID: number) => void;
    setStoryID: (storyID: number) => void;
    setTenantID: (tenantID: string) => void;
}

const useGlobalContext = create<GlobalContextState>((set) => ({
    projectID: null,
    storyID: null,
    tenantID: null,
    setProjectID: (projectID: number) => set(() => ({
        projectID: projectID,
    })),
    setStoryID: (storyID: number) => set(() => ({
        storyID: storyID,
    })),
    setTenantID: (tenantID: string) => set(() => ({
        tenantID: tenantID,
    }))
}));

export default useGlobalContext;